<template>
  <div class="wrapper">
    <div class="page-head2 page-header-mini" :style="{ marginBottom: `${logo_altura}px` }"></div>

    <div class="container" style="padding-top: 30px; padding-bottom: 60px;">
      <div class="row">
        <div class="col-md-10 ml-auto mr-auto">

          <h2 style="font-weight: 800; color: #0045c4;">Realiza tu pago</h2>
          <p class="text-muted">Liquida tu factura pendiente para recuperar el acceso a tu trastero.</p>
          <hr>

          <!-- Estado de carga -->
          <div v-if="!datosCargados && !errorCarga" style="padding: 20px 0; color: #888;">
            Cargando información del pago...
          </div>
          <div v-if="errorCarga" style="padding: 20px 0; color: #f00;">
            No se pudo cargar la información del pago. Por favor contacta con nosotros.
          </div>

          <!-- Resumen factura -->
          <div class="row" v-if="datosCargados">
            <div class="col-sm-8 col-md-7">
              <card>
                <h4 class="card-title">Factura pendiente</h4>
                <p class="card-text" style="font-size: 14px;">
                  <b>Cliente:</b> {{ nombreCompleto }}<br>
                  <span v-if="boxRef"><b>Trastero:</b> {{ boxRef }}<span v-if="centroName"> ({{ centroName }})</span><br></span>
                  <b>Concepto:</b> {{ concepto }}<br>
                  <b>Referencia factura:</b> {{ referencia }}
                </p>
                <p class="card-text text-right" style="font-size: 20px; margin-top: 10px;">
                  Importe a pagar: <b style="color: #0045c4;">{{ importeFormateado }} €</b>
                </p>
              </card>
            </div>
          </div>

          <hr v-if="datosCargados">

          <!-- Email opcional + términos -->
          <div v-if="datosCargados">
            <h4 style="font-weight: 700;">Datos de contacto</h4>
            <p class="text-muted" style="font-size: 13px;">Email para enviarte el recibo (opcional).</p>
            <div class="row" style="padding-top: 10px;">
              <div class="col-md-6 pl-2">
                <label>Email</label>
                <fg-input v-model="email"
                          :error="erroresEmail"
                          @input="validaEmail"
                          @blur="email = email.toLowerCase()"/>
              </div>
            </div>

            <hr>

            <div style="padding: 10px 0 15px 0;">
              <n-checkbox v-model="autorizo">
                Acepto los <router-link to="/terminos">términos del servicio</router-link>
                y la <router-link to="/cookies">Política de Privacidad</router-link>.
              </n-checkbox>
            </div>

            <n-button
              v-if="formularioValido"
              type="info" size="lg"
              style="border: 2px solid #FF6600 !important;"
              @click.native="procesarPago">
              Pagar {{ importeFormateado }} € con Redsys
            </n-button>
            <n-button v-else
              type="info" size="lg"
              :disabled="true"
              style="border: 2px solid #FF6600 !important; cursor: default; opacity: 1;">
              Pagar {{ importeFormateado }} € con Redsys
              <el-tooltip content="Acepta los términos para continuar" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </n-button>

          </div>

        </div>
      </div>
    </div>

    <!-- Modal acepta términos -->
    <modal :show.sync="modalAceptaTerminos" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Acepta los términos</h4>
      <p>Debes aceptar los términos y la Política de Privacidad para continuar.</p>
      <template slot="footer">
        <n-button type="primary" @click.native="modalAceptaTerminos = false">Entendido</n-button>
      </template>
    </modal>

  </div>
</template>

<script>
import { Card, Button, FormGroupInput, Modal, Checkbox } from '@/components'
import { Tooltip, Notification } from 'element-ui'
import { RUTA_PHP } from '@/constants'
import axios from 'axios'

export default {
  name: 'pagar-sms',
  bodyClass: 'blog-post',

  components: {
    Modal,
    Card,
    [Button.name]:         Button,
    [Checkbox.name]:       Checkbox,
    [Tooltip.name]:        Tooltip,
    [FormGroupInput.name]: FormGroupInput,
  },

  props: {
    datos: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      datosCargados: false,
      errorCarga:    false,
      modalAceptaTerminos: false,
      autorizo: false,
      logo_altura: 0,

      // Descifrado del enlace
      centroid:    '',
      centroName:  '',
      boxRef:      '',

      // Datos del pago
      importe:     0,
      concepto:    '',
      referencia:  '',
      internalId:  '',
      externalRef: '',

      // Datos del cliente (read-only, ya existen en el CRM)
      nombre:    '',
      apellido1: '',
      apellido2: '',
      telefono:  '',

      // Editable
      email:        '',
      erroresEmail: '',
    }
  },

  computed: {
    nombreCompleto() {
      return [this.nombre, this.apellido1, this.apellido2].filter(x => x).join(' ')
    },
    importeFormateado() {
      const n = Number(this.importe) || 0
      return n.toFixed(2).replace('.', ',')
    },
    formularioValido() {
      if (!this.autorizo)      return false
      if (!this.datosCargados) return false
      if (this.email && this.erroresEmail) return false
      return true
    },
  },

  methods: {
    validaEmail() {
      const v = (this.email || '').trim()
      if (v.length === 0) {
        this.erroresEmail = ''
        return
      }
      this.erroresEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Email no válido'
    },

    leeDatos() {
      if (!this.datos) {
        console.error('ERROR: prop datos vacía')
        this.errorCarga = true
        return
      }

      const params = new URLSearchParams()
      params.append('datos', this.datos)

      // Reusamos el mismo decoder AES de la contratación
      axios.post(RUTA_PHP + 'bridge-ai-transacContratarSMSDec.php', params)
        .then(response => {
          const d = typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data

          if (!d || d.resp === 'KO') {
            this.errorCarga = true
            return
          }

          // Defensa básica: este componente SOLO acepta payloads tipo "pago"
          if ((d.TIPO || '').toLowerCase() !== 'pago') {
            console.error('Payload no es de tipo pago, llegó:', d.TIPO)
            this.errorCarga = true
            return
          }

          this.centroid    = String(d.CENTRO       || '')
          this.centroName  = String(d.CENTRO_NAME  || '')
          this.boxRef      = String(d.BOX_REF      || '')
          this.importe     = Number(d.AMOUNT       || 0)
          this.concepto    = String(d.CONCEPT      || '')
          this.referencia  = String(d.REFERENCE    || '')
          this.internalId  = String(d.INTERNAL_ID || '')
          this.externalRef = String(d.EXTERNAL_REF || '')

          this.nombre    = String(d.NOMBRE    || '')
          this.apellido1 = String(d.APELLIDO1 || '')
          this.apellido2 = String(d.APELLIDO2 || '')
          this.telefono  = String(d.TELEFONO  || '')

          this.datosCargados = true
        })
        .catch(err => {
          console.error('Error en transacContratarSMSDec:', err)
          this.errorCarga = true
        })
    },

    getId() {
      return (Math.floor(new Date().getTime() / 1000) - 1546300800).toString(36)
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },

    async procesarPago() {
      if (!this.autorizo) {
        this.modalAceptaTerminos = true
        return
      }

      // Redsys importe en céntimos (sin punto)
      const importeStr = String(this.importe.toFixed(2)).replace('.', '')

      // ORIGEN=PAGO_ONLINE engancha con el flujo existente de pasarela_contrato.php
      const oPago = {
        ORIGEN:       'PAGO_ONLINE',
        CENTRO:       this.centroid,
        NOMBRE:       this.nombre,
        APELLIDO1:    this.apellido1,
        APELLIDO2:    this.apellido2,
        TELEFONO:     this.telefono,
        EMAIL:        this.email,
        AMOUNT:       this.importe,
        IDFACTURA:    this.referencia,    // pública, para "Pago Factura: ..."
        IDFACTINT:    this.internalId,    // interna, para POST_VERIFICA_FACTURA
        CONCEPT:      this.concepto,
        EXTERNAL_REF: this.externalRef,
        BOX_REF:      this.boxRef,
        FUENTE:       'SMS_PAGO',
      }

      const merData = JSON.stringify(oPago)
      const ord2    = this.getRandomInt(100, 999).toString(36) + this.getId()

      const params = new URLSearchParams()
      params.append('order',   ord2)
      params.append('importe', importeStr)
      params.append('merdata', merData)
      params.append('centro',  this.centroid)
      params.append('email',   this.email)

      try {
        // Reusamos pasarela_contrato.php — ya maneja PAGO_ONLINE
        const respuesta = await axios.post(RUTA_PHP + 'pasarela_contrato.php', params)

        if (respuesta.data.params === 'KO') {
          Notification.error({
            title:    'Error',
            message:  'La factura no se ha podido verificar o ya está pagada. Inténtalo más tarde o contacta con nosotros.',
            duration: 0,
          })
          return
        }

        const mapForm  = document.createElement('form')
        mapForm.target = '_self'
        mapForm.method = 'POST'
        mapForm.action = this.$store.state.ruta_pasarela_banco

        const addInput = (name, value) => {
          const i = document.createElement('input')
          i.type = 'hidden'; i.name = name; i.value = value
          mapForm.appendChild(i)
        }
        addInput('Ds_SignatureVersion',   'HMAC_SHA256_V1')
        addInput('Ds_MerchantParameters', respuesta.data.params)
        addInput('Ds_Signature',          respuesta.data.signature)

        document.body.appendChild(mapForm)
        mapForm.submit()

      } catch (err) {
        console.error('Error pasarela pago:', err)
        Notification.error({
          title:    'Error de conexión',
          message:  'No se pudo conectar con la pasarela de pago. Inténtalo de nuevo.',
          duration: 5000,
        })
      }
    },
  },

  mounted() {
    this.logo_altura = this.$store.state.logo_altura
    this.leeDatos()
  },
}
</script>

<style scoped>
.page-head2 {
  background-color: #0045c4;
  padding: 0;
  margin-bottom: 0;
}
</style>